<template>
  <BaseVeeForm :action="tryCreateLink" v-slot="{ isPending, invalid }" class="space-y-6">
    <ValidationProvider rules="required" name="url" slim vid="url">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel for="url"> Url </BaseFormLabel>
          <BaseFormInput id="url" v-model="formData.url" type="url" :disabled="isPending" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider name="title" slim vid="title">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel for="title"> Title </BaseFormLabel>
          <BaseFormInput id="title" v-model="formData.title" :disabled="isPending" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider name="description" slim vid="description">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel for="description"> Description </BaseFormLabel>
          <BaseFormTextarea
            id="description"
            rows="3"
            v-model="formData.description"
            :disabled="isPending"
          />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <div class="flex space-x-2">
      <BaseButton primary :disabled="isPending || invalid"> Create Link </BaseButton>
    </div>
  </BaseVeeForm>
</template>

<script>
export default {
  name: 'LinkForm',
  props: {
    action: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        url: '',
        title: '',
        description: '',
      },
    };
  },
  methods: {
    async tryCreateLink() {
      try {
        await this.action(this.formData);
        this.$emit('success');
        return Promise.resolve();
      } catch (error) {
        this.$emit('failure');
        return Promise.reject(error);
      }
    },
  },
};
</script>
